import { HeaderPrintListProps } from "./AddHeaderSapiensPrintList";
import { generateHeaderPdf, getHeaderStaticPdf, mergedPdfHeader } from "./StaticPdfUtils";

// PDF Path
const PDF = "/static/pdf/printList/fm_opd_028.pdf";
const Font = "/static/fonts/THSarabunNew-Bold.ttf"; //* กรณีแก้ Font

const FormArthroscopicTH = async (props: any) => {
  try {
    const pdfPath = props.items?.headerInfo?.file_path ?? PDF;
    const existingPdfBytes = await fetch(pdfPath).then((res) => res.arrayBuffer());
    const pdfBytes = new Uint8Array(existingPdfBytes);

    const headerConfigList: HeaderPrintListProps[] = [
      // Page 1
      { headerMargins: [12, 8, 13, 0], freeLine: 2, extraCanvasHeight: 8 },
      // Page 2
      { headerMargins: [12, 13, 13, 0], freeLine: 2, extraCanvasHeight: 10 },
      // Page 3
      { headerMargins: [12, 13, 13, 0], freeLine: 2, extraCanvasHeight: 26 },
      // Page 4
      { headerMargins: [12, 11, 13, 0], freeLine: 2, extraCanvasHeight: 26 },
    ];

    const headerDefs = await Promise.all(
      headerConfigList.map((config) =>
        getHeaderStaticPdf(
          {
            formName: `${props.items?.headerInfo?.name}\n(${props.items?.headerInfo?.name_en})`,
            patientInfo: props.items,
            detail: props.detail,
            ...config,
          },
          "mini"
        )
      )
    );

    const headerPdfBytesList = await Promise.all(headerDefs.map((def) => generateHeaderPdf(def)));

    const mergedPdfBytes = await mergedPdfHeader(pdfBytes, headerPdfBytesList);

    const blob = new Blob([mergedPdfBytes as BlobPart], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    return {
      uint8Array: mergedPdfBytes,
      blobUrl,
      blobRaw: blob,
      base64String: Buffer.from(mergedPdfBytes).toString("base64"),
    };
  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormArthroscopicTH;
